<template>
    <v-text-field disabled label="Respuesta numérica" outlined dense type="number"></v-text-field>
</template>

<script>
export default {
    name: 'NumberQuestion',
    props: ['question']
}
</script>